import { createAsyncAction, createReducer} from 'typesafe-actions'
import { put, call, takeEvery, all } from 'redux-saga/effects';
import * as api from '../lib/api/subscriber'
import { getListInfoRequestDTO } from '../lib/api/types';
import { AxiosError } from 'axios';

export type listsInfoPayloadType = {
  confirmEmail: string
  createTime: string
  id: string
  isPaidList: boolean
  lastSentTime: string
  listName: string
  modifiedTime: string
  paidSubscriptionItems: paidSubscriptionItem[]
  price: string
  senderEmails: senderEmail[]
  senderName: string
  subscribingCount: string
  subscribingSmsCount: string
  syncTime: string
  updateProgress: string
}

export type paidSubscriptionItem = {
  ItemCode: string
  Period: string
  PeriodType: string
  id: string
  name: string
  price: string
}

export type senderEmail = {
  authorized: string
  email: string
  isDefault: boolean
}

export type getListsInfoState = {
  data: listsInfoPayloadType
  loading: boolean
  error: boolean
  errorData?:AxiosError
}

export const getListsInfo = createAsyncAction(
  'GET_LISTS_INFO',
  'GET_LISTS_INFO_SUCCESS',
  'GET_LISTS_INFO_FAILURE',
)<getListInfoRequestDTO, any, AxiosError>();

type listsInfoAction = ReturnType<typeof getListsInfo.request>

const initialState: getListsInfoState ={
  data:{
    confirmEmail: "",
    createTime: "",
    id: '',
    isPaidList: true,
    lastSentTime: "",
    listName: "",
    modifiedTime: "",
    paidSubscriptionItems: [],
    price: '',
    senderEmails: [],
    senderName: "",
    subscribingCount: '',
    subscribingSmsCount: '',
    syncTime: "",
    updateProgress: ''
  },
  loading: false,
  error: false,
}

function* getLitsInfoSaga(action:listsInfoAction):Generator{
  try{
    const response:any = yield call(
      api.getListInfo,
      action.payload
    )
    yield put(getListsInfo.success(response.data))
  } catch (e) {
    yield put(getListsInfo.failure(e))
  }
}

export function* listsInfoSaga(){
  yield all([takeEvery(getListsInfo.request, getLitsInfoSaga)])
}

export const listsInfo = createReducer<
  getListsInfoState,
  ReturnType<typeof getListsInfo.request>|
  ReturnType<typeof getListsInfo.success>|
  ReturnType<typeof getListsInfo.failure>
>(initialState)
.handleAction(
  getListsInfo.request,
  (state:getListsInfoState, action:{payload:getListInfoRequestDTO}
    )=>({
      ...state,
      loading:true,
      error:false,
    })
)
.handleAction(
  getListsInfo.success,
  (state:getListsInfoState,action:{payload:listsInfoPayloadType})=>({
    ...state,
    loading:false,
    data:action.payload,
  })
).handleAction(
  getListsInfo.failure,
  (state:getListsInfoState,action:{payload:AxiosError})=>({
    ...state,
    loading:false,
    error:true,
    errorData: action.payload 
  })
)

export default listsInfo